export const KEYBOARD_INPUT_DEBOUNCE_DELAY_MS = 800;
export const SAVED_INDICATOR_DISPLAY_DURATION_MS = 2000;
export const DENY_TIMEOUT_MS = 3000;

// API request timeouts
export const SHORT_API_REQUEST_TIMEOUT_MS = 10000; // 10 seconds for short API requests
export const API_REQUEST_TIMEOUT_MS = 30000; // 30 seconds default
export const API_REQUEST_TIMEOUT_90_SEC = 90000; // 90 seconds default
export const SESSION_NOTE_API_REQUEST_TIMEOUT_MS = 120000; // 120 seconds for session note save/submit
export const GENERATE_DAILY_LINK_TIMEOUT_MS = 15000; // 15 seconds for link generation
export const ONE_MINUTE_TIMEOUT_MS = 60000;

export const CLERK_RETRY_DELAY_MS = 500;
